module.exports = __webpack_public_path__ + "static/img/RU.5b8cc000.svg";